import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackTaskSyncBannerDismissed", "trackTaskSyncBannerLinkClicked"];
import { getCalendarSettingsUrl } from '../utils/links';
import { useCallback } from 'react';
import { UserAttributesClient } from 'frontend-preferences-client';
import { useEffect, useMemo, useState } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const HAS_SEEN_TASK_SYNC_BANNER = 'Tasks:has-seen-task-sync-banner';
function useSyncBannerSetting() {
  const [shouldShow, setShouldShow] = useState(false);
  const userAttributesClient = useMemo(() => UserAttributesClient.forCaller('tasks-lib'), []);
  useEffect(() => {
    userAttributesClient.fetch(HAS_SEEN_TASK_SYNC_BANNER, 'false').then(hasSeenBanner => {
      if (hasSeenBanner !== 'true') {
        setShouldShow(true);
      }
    }).catch(() => {
      // In case of any error, do nothing and we won't show the intro
    });
  }, [userAttributesClient]);
  const markAsSeen = useCallback(async () => {
    setShouldShow(false);
    await userAttributesClient.write(HAS_SEEN_TASK_SYNC_BANNER, 'true');
  }, [userAttributesClient]);
  return {
    markAsSeen,
    shouldShow
  };
}
export function TaskSyncBanner(_ref) {
  let {
      trackTaskSyncBannerDismissed,
      trackTaskSyncBannerLinkClicked
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    markAsSeen,
    shouldShow
  } = useSyncBannerSetting();
  const dismissBanner = useCallback(() => {
    if (trackTaskSyncBannerDismissed) {
      trackTaskSyncBannerDismissed();
    }
    markAsSeen().catch(err => {
      throw err;
    });
  }, [markAsSeen, trackTaskSyncBannerDismissed]);
  const LearnMoreLink = useMemo(() => ({
    children
  }) => /*#__PURE__*/_jsx(UILink, {
    href: getCalendarSettingsUrl(),
    onClick: trackTaskSyncBannerLinkClicked || undefined,
    children: children
  }), [trackTaskSyncBannerLinkClicked]);
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, Object.assign({
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-lib.taskSyncBanner.title"
    }),
    closeable: true,
    onClose: dismissBanner
  }, props, {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "tasks-lib.taskSyncBanner.message_jsx",
      elements: {
        Link: LearnMoreLink,
        linkProps: {
          onClick: trackTaskSyncBannerLinkClicked
        }
      }
    })
  }));
}